// "Watch it work" demo, directly under the hero. Silent, looping, autoplaying
// product demo (the Fusion clip). The muted + autoPlay + loop + playsInline
// combo is what actually autoplays on mobile: iOS blocks any unmuted autoplay
// and, without playsInline, force-fullscreens the video. poster shows the first
// frame instantly so there's no blank flash before playback starts.
//
// Responsive: 16:9 FULL-WIDTH on desktop (room for the whole app UI), 4:5 on
// mobile (a 16:9 strip is tiny on a phone; the taller crop shows the interface
// large). Two elements, breakpoint-gated, so each aspect uses its own
// correctly-cropped source file.
export default function VideoDemo() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Heading — kept narrow + centered for readability */}
        <div className="max-w-3xl mx-auto text-center mb-10">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-light text-primary text-xs font-semibold tracking-wider uppercase mb-6">
            <i className="ri-play-circle-line" />
            Watch it work
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-dark leading-[1.1] tracking-tight mb-4">
            Your product becomes an ad,{' '}
            <span className="text-primary">in seconds.</span>
          </h2>
          <p className="text-dark-muted text-base md:text-lg leading-relaxed">
            This is Fusion building a fresh, on-brand ad from a single product.
            No designer, no prompts, no blank canvas.
          </p>
        </div>

        {/* Desktop 16:9 — full width, capped at the video's native 1920 so it
            never upscales (stays sharp) on ultra-wide monitors. */}
        <div className="relative hidden md:block w-full max-w-[1920px] mx-auto aspect-video rounded-3xl overflow-hidden gradient-stroke shadow-2xl shadow-primary/10 bg-black">
          <video
            className="w-full h-full object-cover block"
            src="/Fusion6-web.mp4"
            poster="/Fusion6-poster.jpg"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-label="Ad Astronaut Fusion demo — a fresh ad built from one product"
          />
        </div>

        {/* Mobile — dedicated vertical recording (660x1080 ≈ 11:18) so the app
            UI reads large on a phone. */}
        <div className="relative md:hidden max-w-sm mx-auto aspect-[11/18] rounded-2xl overflow-hidden gradient-stroke shadow-2xl shadow-primary/10 bg-black">
          <video
            className="w-full h-full object-cover block"
            src="/Fusion-mobile-web.mp4"
            poster="/Fusion-mobile-poster.jpg"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-label="Ad Astronaut Fusion demo — a fresh ad built from one product"
          />
        </div>
      </div>
    </section>
  );
}
